export const FORM_NAME = 'RS_PROTOCOL_FORM';
export const QA_ID = 'rs-protocol-protocol-form-modal';
